import { Breadcrumbs } from 'AbstractElements';
import QuestionContain from 'Component/Learning/BankQuestion';

const QuestionList = () => {
    return (
        <>
            <Breadcrumbs mainTitle="Bank Soal" parent="Learning" title="Bank Soal" />
            <QuestionContain />
        </>
    );
};
export default QuestionList;